import _createForOfIteratorHelper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectSpread from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { get as _get, toNumber } from './utils.js';
import Rule from './Rule.js';
import CalEvent from './CalEvent.js';
var PostRule = /*#__PURE__*/function () {
  /**
   * @param {String} ruleStr
   * @param {Object} opts
   * @param {Array} [holidays]
   */
  function PostRule(ruleStr, opts, holidays) {
    _classCallCheck(this, PostRule);
    this.opts = opts;
    this.ruleStr = ruleStr;
    this.ruleSet = holidays && holidays[ruleStr];
    this.holidays = holidays;
    this.events = [];
  }
  _createClass(PostRule, [{
    key: "push",
    value: function push(calEvent) {
      this.events.push(calEvent);
    }

    /**
     * @param {number} year
     * @returns {CalEvent}
     */
  }, {
    key: "getEvent",
    value: function getEvent(year) {
      var active = this.ruleSet && this.ruleSet.active;
      this.disable(year);
      var ev = this.events[0];
      ev.filterActive(year, active);
      return ev;
    }

    /**
     * @param {Array} rule
     * @param {number} year
     */
  }, {
    key: "resolve",
    value: function resolve(rule, year) {
      if (rule.rule && typeof this[rule.rule] === 'function') {
        this[rule.rule](rule, year);
      }
    }

    /**
     * @param {Array} rule
     * @param {number} year
     */
  }, {
    key: "bridge",
    value: function bridge(rule, year) {
      var found = new Array(this.events.length).fill(false);
      found[0] = true;
      var type = rule.type || 'public';

      // get all holidays of the given year
      for (var ruleStr in this.holidays) {
        var dateFn = this.holidays[ruleStr].fn;
        if (dateFn && dateFn.ruleStr !== this.ruleStr) {
          var tmpEv = dateFn.inYear(year);
          var tmpEvType = _get(tmpEv, 'opts.type') || 'public';
          for (var i = 1; i < this.events.length; i++) {
            if (found[i]) continue;
            var isEqualDate = tmpEv.event.isEqualDate(this.events[i]);
            if (isEqualDate && tmpEvType === type) {
              found[i] = true;
            }
          }
        }
        if (!~found.indexOf(false)) {
          // pre-exit if all found
          break;
        }
      }
      if (~found.indexOf(false)) {
        this.events[0].reset();
      }
    }
  }, {
    key: "ruleIfHoliday",
    value: function ruleIfHoliday(rule, year) {
      var type = rule.type || 'public';

      // get all holidays of the given year
      for (var ruleStr in this.holidays) {
        var dateFn = this.holidays[ruleStr].fn;
        if (dateFn && dateFn.ruleStr !== this.ruleStr) {
          var tmpEv = dateFn.inYear(year);
          var tmpEvType = _get(tmpEv, 'opts.type') || 'public';
          for (var i = 0; i < this.events.length; i++) {
            var isEqualDate = tmpEv.event.isEqualDate(this.events[i]);
            if (isEqualDate && tmpEvType === type) {
              new Rule(this.events[i]).resolve(_objectSpread(_objectSpread({}, rule), {}, {
                rule: 'dateDir'
              }));
              return;
            }
          }
        }
      }
    }

    /**
     * @param {number} year
     */
  }, {
    key: "disable",
    value: function disable(year) {
      var _ref = this.opts || {},
        disable = _ref.disable,
        enable = _ref.enable;
      if (!disable || !disable.length) return;
      var ev = this.events[0];

      // check if exact event was disabled or moved
      var tmpEv = _findEventInYear(year, disable);
      if (tmpEv) {
        if (tmpEv.isEqualDate(ev)) {
          ev.reset();
          tmpEv = _findEventInYear(year, enable);
          if (tmpEv) this.events[0] = tmpEv;
        }
        return;
      }

      // simply check if the event can be disabled for year-(month)
      var _findDisabled2 = _findDisabled(year, disable),
        _findDisabled3 = _slicedToArray(_findDisabled2, 2),
        _year = _findDisabled3[0],
        _month = _findDisabled3[1];
      ev.filterDisabled(_year, _month);
    }
  }]);
  return PostRule;
}();
export { PostRule as default };
var isoDate = function isoDate(isoDateStr) {
  return String(isoDateStr).split('-').map(function (v) {
    return toNumber(v);
  });
};
function _findEventInYear(_year) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _iterator = _createForOfIteratorHelper(arr),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var _isoDate = isoDate(item),
        _isoDate2 = _slicedToArray(_isoDate, 3),
        year = _isoDate2[0],
        month = _isoDate2[1],
        day = _isoDate2[2];
      if (year === _year && month && day) {
        return new CalEvent({
          year: year,
          month: month,
          day: day
        }).inYear(year);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function _findDisabled(_year) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _iterator2 = _createForOfIteratorHelper(arr),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var isoDateStr = _step2.value;
      var _isoDate3 = isoDate(isoDateStr),
        _isoDate4 = _slicedToArray(_isoDate3, 2),
        year = _isoDate4[0],
        month = _isoDate4[1];
      if (_year === year) {
        return [year, month];
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return [];
}